<template>
  <div class="app">
    <div><head1></head1></div>
    <div class="banner">
      <div class="l-banner">
        <img src="@/assets/images/list_banner.jpg" alt="" width="100%" />
      </div>
      <div class="banner-title">
        <h1>津旅品牌</h1>
        <div class="banner_title_line"></div>
      </div>
    </div>
    <div class="bread-nav">
      <span>您的位置：</span>
      <span @click="home()" class="nav-item">首页</span>
      <span class="possplit"></span>
      <span>津旅品牌</span>
      <!-- <span class="possplit" v-if="index1 == 1"></span>
      <span v-if="index1 == 1">党建工作</span>
      <span class="possplit" v-if="index1 == 2"></span>
      <span v-if="index1 == 2">学习园地</span> -->
    </div>
    <div class="mgb80">
      <div class="content-web">
        <div class="left_nav">
          <div class="left_nav_title">
            <h1>津旅品牌</h1>
            <div class="left_nav_line"></div>
          </div>
          <div class="col_menu_con">
            <div class="col_list">
              <el-menu
                unique-opened
                default-active="1"
                @select="handleSelect1"
                class="el-menu-vertical-demo"
                background-color="#023A8F"
                text-color="#fff"
                active-text-color="#206BD1"
              >
                <el-submenu index="1">
                  <template slot="title"
                    ><div class="test1" @click="jdbk()">酒店板块</div></template
                  >
                  <el-menu-item index="2"
                    ><span :class="index1 == 2 ? 'activeColor' : ''"
                      >利顺德大饭店</span
                    ></el-menu-item
                  >
                  <el-menu-item index="3"
                    ><span :class="index1 == 3 ? 'activeColor' : ''"
                      >燕园国际大酒店</span
                    ></el-menu-item
                  >
                  <el-menu-item index="4"
                    ><span :class="index1 == 4 ? 'activeColor' : ''"
                      >友谊宾馆</span
                    ></el-menu-item
                  >
                  <el-menu-item index="5"
                    ><div :class="index1 == 5 ? 'activeColor' : ''"
                      ><div>天津港旅物业管理旅</div><div>游培训有限公司</div></div
                    ></el-menu-item
                  >
                  <el-menu-item index="6"
                    ><span :class="index1 == 6 ? 'activeColor' : ''"
                      >利顺德大厦</span
                    ></el-menu-item
                  >
                </el-submenu>
                <el-submenu index="2">
                  <template slot="title"
                    ><div class="test1" @click="lybk()">旅游板块</div></template
                  >
                  <el-menu-item index="7"
                    ><span :class="index1 == 7 ? 'activeColor' : ''"
                      >津食集团</span
                    ></el-menu-item
                  >
                  <el-menu-item index="8"
                    ><span :class="index1 == 8 ? 'activeColor' : ''"
                      >天津国旅</span
                    ></el-menu-item
                  >
                  <el-menu-item index="9"
                    ><span :class="index1 == 9 ? 'activeColor' : ''"
                      >海河游船公司</span
                    ></el-menu-item
                  >
                  <el-menu-item index="10"
                    ><span :class="index1 == 10 ? 'activeColor' : ''"
                      >津旅商务</span
                    ></el-menu-item
                  >
                  <el-menu-item index="11"
                    ><span :class="index1 == 11 ? 'activeColor' : ''"
                      >国展中心</span
                    ></el-menu-item
                  >
                </el-submenu>
                <el-submenu index="3">
                  <template slot="title"
                    ><div class="test1" @click="zhpt()">
                      综合配套板块
                    </div></template
                  >
                  <el-menu-item index="12"
                    ><span :class="index1 == 12 ? 'activeColor' : ''"
                      >旅游汽车公司</span
                    ></el-menu-item
                  >
                  <el-menu-item index="13"
                    ><span :class="index1 == 13 ? 'activeColor' : ''"
                      >津旅物业</span
                    ></el-menu-item
                  >
                  <el-menu-item index="14"
                    ><span :class="index1 == 14 ? 'activeColor' : ''"
                      >北方人才港</span
                    ></el-menu-item
                  >
                  <el-menu-item index="15"
                    ><span :class="index1 == 15 ? 'activeColor' : ''"
                      >新远进出口</span
                    ></el-menu-item
                  >
                </el-submenu>
              </el-menu>
            </div>
          </div>
        </div>
        <div class="inner_content_right">
          <jdbk v-if="index1 == 'jdbk'"></jdbk>
          <lsd v-if="index1 == '2'"></lsd>
          <yygj v-if="index1 == '3'"></yygj>
          <yybg v-if="index1 == '4'"></yybg>
          <tjgly v-if="index1 == '5'"></tjgly>
          <lsdds v-if="index1 == '6'"></lsdds>
          <lybk v-if="index1 == 'lybk'"></lybk>
          <jsjt v-if="index1 == '7'"></jsjt>
          <tjgl v-if="index1 == '8'"></tjgl>
          <hhyc v-if="index1 == '9'"></hhyc>
          <jlsw v-if="index1 == '10'"></jlsw>
          <gzzx v-if="index1 == '11'"></gzzx>
          <zhpt v-if="index1 == 'zhpt'"></zhpt>
          <lyqc v-if="index1 == '12'"></lyqc>
          <jgwy v-if="index1 == '13'"></jgwy>
          <bfrc v-if="index1 == '14'"></bfrc>
          <xyjck v-if="index1 == '15'"></xyjck>
          <jlpp v-if="index1 == 'jlpp'"></jlpp>
        </div>
      </div>
    </div>

    <div class="footer">
      <foot></foot>
    </div>
    <div class="footer-bottom">
     <bottom></bottom>
    </div>
  </div>
</template>

<script>
// import HelloWorld from './components/HelloWorld.vue'
// import djgz from "./djgz.vue";
import jlpp from "./jlpp.vue";
import xyjck from "./xyjck.vue";
import zhpt from "./zhpt.vue";
import lybk from "./lybk.vue";
import lsdds from "./lsdds.vue";
import tjgly from "./tjgly.vue";
import yybg from "./yybg.vue";
import jdbk from "./jdbk.vue";
import gzzx from "./gzzx.vue";
import bfrc from "./bfrc.vue";
import jlsw from "./jlsw.vue";
import jgwy from "./jgwy.vue";
import lyqc from "./lyqc.vue";
import tjgl from "./tjgl.vue";
import hhyc from "./hhyc.vue";
import jsjt from "./jsjt.vue";
import lsd from "./lsd.vue";
import yygj from "./yygj.vue";
import foot from "../footer.vue";
import head1 from "../head.vue";
import bottom from "../bottom.vue";
export default {
  name: "App",
  components: {
    bottom,
    jdbk,
    lybk,
    jlpp,
    head1,
    lsd,
    foot,
    yygj,
    yybg,
    tjgly,
    lsdds,
    jsjt,
    tjgl,
    hhyc,
    jlsw,
    gzzx,
    zhpt,
    lyqc,
    jgwy,
    bfrc,
    xyjck,
  },
  data() {
    return {
      images: [
        { id: 1, url: require("@/assets/images/1.png"), qq: "水电费水电费" },
        { id: 2, url: require("@/assets/images/2.png"), qq: "而威尔" },
        { id: 3, url: require("@/assets/images/4.png"), qq: "水电费是的" },
      ],
      index: "1",
      index1: "1",
      radio1: "overview",
      
    };
  },
  watch: {
    $route: {
      handler: function (newValue) {
        this.index1 = newValue.query.index1;
      },
    },
    deep: true,
  },

  created() {
    this.index1 = this.$route.query.index1;
  },
  methods: {
    handleSelect(key, keyPath) {
      console.log(key, keyPath);
    },
        home() {
      this.$router.push("/");
    },
    jdbk() {
      this.index1 = "jdbk";
    },
    zhpt() {
      this.index1 = "zhpt";
    },
    lybk() {
      this.index1 = "lybk";
    },
    handleSelect1(key) {
      // console.log(key, 88);
      this.index1 = key;
    },
    jtjj() {
      this.$router.push("/147");
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
    },
  },
};
</script>

<style lang="scss" scoped>
.activeColor {
  color: #206bd1 !important;
}
.mgb80 .content-web .el-menu-item {
  height: 100% !important;
}
.el-submenu__title {
  background-color: #fff !important;
}
.el-menu.el-menu--horizontal {
  display: flex;
  justify-content: center;
}
.el-menu--horizontal > .el-submenu .el-submenu__title {
  font-size: 16px;
  width: 180px;
  text-align: center;
}
.el-menu--horizontal > .el-menu-item:first-child {
  margin-left: 0px !important;
  margin-right: 0px !important;
}
.el-menu-item {
  width: 180px;
  text-align: center;
}
.el-menu--popup .el-menu-item {
  min-width: 0px !important;
}
.el-menu--popup .el-menu-item:hover {
  border-left: 0px !important;
}
.app {
   background-color: #f3f3f3;
}
.nav-item {
  cursor: pointer;
}
.test1 {
  background-color: #fff !important;
  color: #666 !important;
  font-weight: 400;
  width: 219px;
  height: 100%;
  font-size: 16px;
  margin: 9px -20px;
  text-align: center;
  border-bottom: 1px solid #f3f3f3;
}

.test {
  border: none !important;
  .el-menu {
    width: 180px;
    background-color: rgba(255, 255, 255, 0.85) !important;
    .el-menu-item {
      background-color: #fff !important;
      color: #fff !important;
      font-weight: 400;
      width: 90%;
      height: 30px !important;
      font-size: 16px;
      margin: 5px 9px;
      text-align: center;
    }
  }
}
.banner {
  position: relative;
  width: 100%;
  height: 350px;
  z-index: 99;
  .l-banner {
    height: 100%;
    background-position: center center;
    background-repeat: no-repeat;
    text-align: center;
    margin: 0 auto;
    background-size: cover;
    width: 100%;
    overflow: hidden;;
    img {
      height: 326%;
      position: relative;
      top: -393px;
    }
  }
  .banner-title {
    position: absolute;
    bottom: 0;
    left: 50%;
    margin-left: -600px;
    box-sizing: border-box;
    padding-left: 41px;
    padding-top: 25px;
    width: 1200px;
    height: 110px;
    background-color: rgba(255, 255, 255, 0.8);
    h1 {
      font-size: 28px;
      color: #333;
    }
    .banner_title_line {
      width: 108px;
      height: 3px;
      margin: 3px 0;
      background-color: #88cc2f;
    }
  }
}
.bread-nav {
  width: 1200px;
  margin: 25px auto 0 auto;
  font-size: 14px;
  color: #666;
  span {
    margin-right: 20px;
  }
  .possplit {
    position: relative;
    top: 3px;
    display: inline-block;
    margin: 0 10px;
    width: 1px;
    height: 16px;
    background-color: #acacac;
    background-image: none;
    margin-right: 20px;
  }
}
.mgb80 {
  margin-bottom: 80px;
  margin-top: 30px;
  .content-web {
    .el-menu {
      background-color: #fff !important;
    }
    .el-menu-item {
      width: 220px !important;
      background-color: #fff !important;
      font-size: 16px !important;
      color: #666 !important;
      border-bottom: 1px solid #f3f3f3;
      // padding-top: 15px !important;
      // padding-bottom: 15px !important;
      // padding-left: 15px !important;
    }
    display: flex;
    width: 1200px;
    // min-width: 1200px;
    margin: 0 auto;
    .left_nav {
      margin-right: 20px;
      height: 100%;
      display: inline;
      float: left;
      width: 220px;
      background-color: #fff;
      .left_nav_title {
        box-sizing: border-box;
        padding: 23px 20px 18px 40px;
        background-color: #206bd1;
        h1 {
          font-size: 22px;
          color: #fff;
        }
        .left_nav_line {
          height: 1px;
          background-color: #fff;
          opacity: 0.2;
          margin-top: 8px;
          margin-bottom: 5px;
        }
      }
      .left_nav_list {
        cursor: pointer;
        box-sizing: border-box;
        padding: 0 10px 20px 10px;
        .left_nav_item {
          box-sizing: border-box;
          padding-top: 15px;
          padding-bottom: 15px;
          padding-left: 15px;
          border-bottom: 1px solid #f3f3f3;
        }
      }
      .select1 {
        color: #206bd1;
      }
      .li1::before {
        position: relative;
        left: -8px;
        top: 4px;
        width: 4px;
        content: "";
        background-color: #206bd1;
        height: 21px;
        display: inline-block;
      }
      // .left_nav_item:hover {
      //   color: #206bd1;
      //   border-left: 1px solid red;
      // }
      // .select2::afte:hover {
      //   position: relative;
      //   left: -8px;
      //   top: 4px;
      //   width: 200px;
      //   content: "";
      //   background-color: #206bd1;
      //   height: 21px;
      //   display: inline-block;
      // }
    }
    .inner_content_right {
      // float: right;
      box-sizing: border-box;
      width: 960px;
      min-height: 600px;
      // margin-left: 20px;
      background-color: #fff;
      .wp_single.wp_column_article {
        padding: 48px 40px 100px 40px;
      }
      .wp_entry {
        line-height: 2em !important;
        font-size: 14px !important;
        font-family: "宋体" !important;
        width: 100%;
        line-height: 1.7em;
        font-size: 13px;
        color: #333;
        overflow: hidden;;
        .head {
          // border-bottom: 1px #444 dashed;
          // height: 500px;
        }
      }
      .text {
        text-indent: 45px;
      }
      .ltd {
        float: right;
      }
    }
  }
}

.jicon {
  background: url(@/assets/images/icon-ba.png) no-repeat center left;
  padding-left: 12px;
}
// ::v-deep .el-menu--popup {
//   display: flex;
//   flex-wrap: wrap;
//   width: 850px !important;
//   background-color: #2d68c1 !important;
// }
.footer-bottom {
  height: 50px;
  min-width: 1200px;
  background-color: #424242;
}
.tjlyjt {
  text-align: center;
  margin-top: 14px;
  font-size: 14px;
  color: #fff;
}
.line {
  width: 100%;
  height: 1px;
  margin: 17px 0;
  background-color: rgba(255, 255, 255, 0.3);
}
.footer-inner-right {
  margin-left: 50px;
  width: 310px;
}
.footer-inner-right-con {
  display: flex;
  margin-top: 40px;
}
.footer-inner-right-con-li {
  margin-right: 35px;
}
.footer-inner-con {
  width: 310px;
}
.footer-inner-one {
  display: flex;
  align-items: center;
}
.footer-inner-left {
  margin-right: 50px;
  width: 310px;
}
.footer-inner-left-tit {
  /* position: absolute;
  left: 0;
  top: 8px; */
  margin-right: 10px;
  content: "";
  display: block;
  width: 10px;
  height: 10px;
  background-color: #00eb9b;
}
.footer-inner-left-title {
  font-size: 18px;
  color: #fff;
}
.footer-inner-left-title2 {
  color: #fff;
  font-size: 16px;
  margin-top: 18px;
}
.footer-inner-left-title1 a {
  color: #fff;
  font-size: 16px;
  text-decoration: none;
  cursor: pointer;
}
.footer-inner {
  display: flex;
  padding-top: 30px;
  margin-left: 462px;
}
.footer-con {
  height: 280px;
  min-width: 1200px;
  background-color: #004aba;
}
.footer-nav {
  height: 51px;
  min-width: 1200px;
  background-color: #023a8f;
  .cyqy {
    width: 850px;
  }
}
.transtion {
  font-size: 16px;
  font-weight: 400;
  color: #ffffff;
}
.fl {
  margin-right: 20px;
  width: 159px;
  height: 158px;
  background: rgba(0, 108, 255, 0.45);
  cursor: pointer;
}
.industry {
  width: 100%;
  height: 250px;
  margin-top: 36px;
  position: relative;
  padding-top: 25px;
  margin-bottom: 35px;
  background: url(@/assets/images/industry.png) no-repeat;
  background-size: 100% 100%;
}
.more {
  float: right;
  margin-top: 34px;
}
.pic-info {
  top: -60px;
  position: relative;
  z-index: 99;
  bottom: 0;
  line-height: 60px;
  background: rgba(51, 51, 51, 0.6);
  width: 96%;
  font-size: 18px;
  color: #fff;
  padding: 0 2%;
  overflow: hidden;;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.mor-btn {
  /* width: 175.88px; */
  cursor: pointer;
  text-align: center;
  line-height: 36px;
  background: #f7f7f7;
  color: #919493;
  padding: 0 50px;
  /* display: inline-block; */
}
.li-content {
  display: flex;
}
.list-title {
  float: left;
  font-size: 16px;
  overflow: hidden;;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 80%;
}
.list-title a {
  color: #919493;
  display: inline;
  text-decoration: none;
}
.news_list {
  width: 570px;
  height: 330px;
}
.news-title {
  line-height: 54px;
  border-bottom: 1px solid #ccc;
  font-size: 16px;
  color: #919493;
}
.left {
  width: 600px;
}
.right {
  margin-left: 30px;
}
.select:hover {
  background: url(@/assets/images/select.png) no-repeat;
  padding-bottom: 10px;
  color: #fff;
}
.li-radio {
  display: flex;
  justify-content: center;
  height: 45px;
  margin-bottom: 25px;
}
.li-radio li {
  text-align: center;
  display: inline-block;
  background: #f1f1f9;
  margin: 0 6px;
  font-size: 20px;
  width: 177px;
  line-height: 40px;
  height: 40px;
}
.title {
  margin-bottom: 50px;
}
.a-title {
  color: #970f11;
  text-decoration: none;
  font-size: 30px;
  font-weight: bold;
  text-align: center;
}
.el-carousel__item h3 {
  color: #475669;
  font-size: 14px;
  opacity: 0.75;
  line-height: 150px;
  margin: 0;
}

.el-carousel__item:nth-child(2n) {
  background-color: #99a9bf;
}

.el-carousel__item:nth-child(2n + 1) {
  background-color: #d3dce6;
}
::v-deep .el-carousel__indicators {
  z-index: 0 !important;
}
.logo-content {
  margin: 20px 0 20px 0;
  display: flex;
  justify-content: space-around;
  /* width: 1200px; */
  /* height: 100px; */
  /* line-height: 100px; */
  text-align: center;
}
</style>
